export const TOKEN_REFRESH_INTERVAL = 5 * 60 * 1000;
